export default "<ngx-auth-firebaseui-register\n  providers=\"firebase\"\n  (onLoginRequested)=\"handleLogin()\"\n></ngx-auth-firebaseui-register>\n"